import { TranslationContext } from 'contexts/translation-context';
import styled from 'styled-components';
import { useContext } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FormikProps } from 'formik';
import { JoinFormType } from 'types/join';

const Subscribe = styled.span`
  font-family: ${props => props.theme.fonts.interSans};
  font-size: 14px;
  line-height: 1.45;
  @media (max-width: 999px) {
    font-size: 11px;
  }
  color: #434343;
  display: inline-flex;
  align-items: center;
`;

const CheckboxContainer = styled.div`
  margin-top: 9px;

  & .MuiFormControlLabel-root {
    align-items: center;
    margin-left: 0;
    margin-right: 0;
    gap: 8px;
  }
  & .MuiFormControlLabel-label {
    display: inline-flex;
    align-items: center;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  @media (max-width: 999px) {
    align-self: self-start;
  }
  && {
    & .MuiFormControlLabel-label {
      font-family: 'Inter', 'Montserrat-Regular', sans-serif;
      font-size: 14px;
      display: flex;
      align-items: center;
    }
    color: ${props => props.theme.colors.siteIndigo};
    &.Mui-checked {
      color: ${props => props.theme.colors.siteIndigo};
    }
  }
`;
const CheckboxBox = styled.span`
  width: 16px;
  height: 16px;
  border: 1.5px solid ${props => props.theme.colors.siteIndigo};
  border-radius: 3px;
  background-color: ${props => props.theme.colors.white};
  box-sizing: border-box;
  display: inline-block;
`;
const CheckboxCheckedBox = styled(CheckboxBox)`
  background-color: ${props => props.theme.colors.siteIndigo};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid ${props => props.theme.colors.white};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const NewsLettersMoreDetailsContent = ({
  form,
  disabled = false
}: {
  form: FormikProps<JoinFormType>;
  disabled: boolean;
}) => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  const isSubscribed =
    form.values.newsBriefNewsletter &&
    form.values.tradeWireNewsletter &&
    form.values.biMonthlyMagazineOnline &&
    !form.values.weeklyJewelryNewsletter;

  const toggleNewsletters = () => {
    const nextValue = !isSubscribed;
    form.setFieldValue('newsBriefNewsletter', nextValue);
    form.setFieldValue('tradeWireNewsletter', nextValue);
    form.setFieldValue('biMonthlyMagazineOnline', nextValue);
    form.setFieldValue('weeklyJewelryNewsletter', false);
  };

  return (
    <CheckboxContainer>
      <Row>
        <FormControlLabel
          label={<Subscribe>{TRANSLATION_TEXT.subscribe_to_rapaport_newsletters}</Subscribe>}
          control={
            <StyledCheckbox
              disabled={disabled}
              checked={isSubscribed}
              onChange={toggleNewsletters}
              color="primary"
              icon={<CheckboxBox />}
              checkedIcon={<CheckboxCheckedBox />}
            />
          }
        />
      </Row>
    </CheckboxContainer>
  );
};

export default NewsLettersMoreDetailsContent;
